import { render, staticRenderFns } from "./QSeccion.vue?vue&type=template&id=ff9c2a10"
import script from "./QSeccion.vue?vue&type=script&lang=js"
export * from "./QSeccion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports